<template>
  <q-page>
    <div class="q-ma-md render-container" v-html="renderedMd"></div>
  </q-page>
</template>

<script>
import { updateCustomMd } from '../../js/customMdParse/customMdParse'

export default {
  name: 'home',
  data () {
    return {
      content: `# The Tech Driving Submind
Submind is an experiment combining many new web technologies to leverage flexibility and
breadth of usability.  At it's core Submind is a [Progressive Web App](https://medium.freecodecamp.org/progressive-web-apps-bridging-the-gap-between-web-and-mobile-apps-a08c76e3e768) based harnessing
[Google Cloud Firestore](https://firebase.google.com/docs/firestore/) for database and 'serverless' backend commands (things that we can't
trust the user to run).  It makes use of [Vue](https://vuejs.org/) and [Quasar](http://quasar-framework.org/) for the frontend and exposes the power
of those systems to the user. The core functionality that the uses interacts with is mostly
handled by some custom code around the [marked](https://github.com/markedjs/marked) markdown
parser and the fantastic [ace](https://ace.c9.io/) code editor.

Here are some of the advantages of this stack:
- Works offline.  Priortising availability over consistency - [CAP](https://en.wikipedia.org/wiki/CAP_theorem).
- Same code runs on PC's, tablets and mobile phones.
- PWA features allow 'installing' the app on mobile devices any extra code.
- Google Cloud Firestore handles all the database synchronisation with [IndexedDB](https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API)
  and supports fast response time by writing to local cache and pushing to server in background.
- Serverless architecture with Google Cloud Firestore is built to scale. Firestore supports automatic multi-region data replication, and has strong consistency guarantees.
- Serverless architecture means most of the heavy lifting is done on the user's device.
- It's also fast!  Public queries and static assets are cached by Google's CDN.
- Easy to spin up a local dev environment and serve everything from your own PC (once logged in).
  This makes development responsive and possible without an internet connection.
- Super awesome and flexible front-end development with Vue and Quasar with webpack and ES6.

Drawbacks of this stack:
- Some of these technologies are still new and are therefore more likely to have bugs or implement breaking changes.
- Have little control over pricing of Google Cloud Firestore.
- More time investment into learning new technologies.
- Google Cloud Firestore is not Open Source. (This is a huge disadvantage in my opinion.)

`,
      ignoreText: `## PWA
Submind is built as a [Progressive Web App](https://medium.freecodecamp.org/progressive-web-apps-bridging-the-gap-between-web-and-mobile-apps-a08c76e3e768)
which means that it works both online and offline, loads quickly and can be used on both desktop
and mobile devices. Using PWA with [Google Cloud Firestore](https://firebase.google.com/docs/firestore/)
allows for an extremely flexible`,
      renderedMd: '',
      componentDefinitionAry: []
    }
  },
  mounted () {
    this.renderedMd = updateCustomMd(this.content || '', this.componentDefinitionAry, this.item, null, false, this.saveThrottled) // eslint-disable-line vue/no-side-effects-in-computed-properties
    this.renderedMd = this.renderedMd + '<div style="width: 100%; height: 25vh;"></div>' // eslint-disable-line vue/no-side-effects-in-computed-properties
    // updateComponentHtmlInDOM()
  }
}
</script>

<style scoped>

</style>
